import React from "react";
import { Box, Typography } from "@mui/material";

const EnvironmentBanner: React.FC = () => {
  const env = process.env.REACT_APP_ENV;

  console.log("Environment Banner Rendered:", env);
  console.log('Color from Azure:', process.env.REACT_APP_COLOR);
  console.log("All env variables:", process.env);

  if (env === "production" || !env) {
    return null;
  }

  const bannerColor = env === "stage" ? "#ff4444" : "#2196f3";
  const bannerText =
    env === "stage" ? "Stage Environment" : "Development Environment";

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: bannerColor,
        color: "white",
        textAlign: "center",
        padding: "4px 0",
        position: "sticky",
        top: 0,
        zIndex: 1200,
      }}
    >
      <Typography variant="body2" fontWeight="medium">
        {bannerText}
      </Typography>
    </Box>
  );
};

export default EnvironmentBanner;
